const STEP_LABELS = [
  'IDENTIDADE VISUAL',
  'NOMEAÇÃO DO ENCARREGADO DE DADOS',
  'AVISO DE PRIVACIDADE',
  'SITE',
  'COOKIES',
]

const VISUAL_IDENTITY_TAG = 'visual_identity'
const DPO_APPOINTMENT_TAG = 'dpo_appointment'
const COMPANY_DOCUMENTS_TAG = 'company_documents'
const COMPANY_SITE_TAG = 'company_site'
const COOKIE_BANNER_TAG = 'cookie_banner'
const CONCLUSION_TAG = 'conclusion'

const VISUAL_IDENTITY_FIRST_STEP_INDEX = [0, 0]
const LOGO_STEP_INDEX = [0, 1]
const CUSTOM_COLORS_STEP_INDEX = [0, 2]
const STEP_DPO_APPOINTMENT_INDEX = [1, 0]
const STEP_DOCS_INDEX = [2, 0]
const STEP_DOCS_FORM_INDEX = [2, 1]
const SITE_CONFIRM_STEP_INDEX = [3, 0]
const SITE_FORM_INDEX = [3, 1]
const STEP_SITE_CONFIG_INDEX = [3, 2]
const STEP_COOKIE_INFO_INDEX = [4, 0]
const STEP_COOKIE_CONFIRM_INDEX = [4, 1]
const STEP_CONCLUSION_INDEX = [5, 0]

const STEP_VISUAL_IDENTITY = 0
const STEP_DPO_APPOINTMENT = 1
const STEP_DOCS = 2
const STEP_SITE = 3
const STEP_COOKIE = 4
const STEP_CONCLUSION = 5

const HAS_BANNER_OBS = 'Já possui banner'

const userTrailSteps = {
  COMPANY_DOCUMENTS_TAG,
  COMPANY_SITE_TAG,
  CONCLUSION_TAG,
  COOKIE_BANNER_TAG,
  CUSTOM_COLORS_STEP_INDEX,
  DPO_APPOINTMENT_TAG,
  HAS_BANNER_OBS,
  LOGO_STEP_INDEX,
  SITE_CONFIRM_STEP_INDEX,
  SITE_FORM_INDEX,
  STEP_CONCLUSION_INDEX,
  STEP_CONCLUSION,
  STEP_SITE_CONFIG_INDEX,
  STEP_COOKIE_CONFIRM_INDEX,
  STEP_COOKIE_INFO_INDEX,
  STEP_COOKIE,
  STEP_DOCS,
  STEP_DOCS_FORM_INDEX,
  STEP_DOCS_INDEX,
  STEP_DPO_APPOINTMENT,
  STEP_DPO_APPOINTMENT_INDEX,
  STEP_LABELS,
  STEP_SITE,
  STEP_VISUAL_IDENTITY,
  VISUAL_IDENTITY_FIRST_STEP_INDEX,
  VISUAL_IDENTITY_TAG,
}

export default userTrailSteps
